/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Detail_Signals_Check_PassedInputs */

const en_directory_detail_signals_check_passed = /** @type {(inputs: Directory_Detail_Signals_Check_PassedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} passed`)
};

const zh_directory_detail_signals_check_passed = /** @type {(inputs: Directory_Detail_Signals_Check_PassedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 项通过`)
};

/**
* | output |
* | --- |
* | "{count} passed" |
*
* @param {Directory_Detail_Signals_Check_PassedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_check_passed = /** @type {((inputs: Directory_Detail_Signals_Check_PassedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Check_PassedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_check_passed(inputs)
	return zh_directory_detail_signals_check_passed(inputs)
});
export { directory_detail_signals_check_passed as "directory.detail.signals.check_passed" }